import { Typography, Show } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';

export const ResourceBankEmptyState = ({
  isDescriptionVisible,
}: {
  isDescriptionVisible: boolean;
}) => {
  return (
    <Flex
      flexDirection="column"
      gap="var(--spacing02)"
      height="100%"
      justifyContent="center"
    >
      <Typography>🧐</Typography>
      <Typography
        type="heading"
        fontWeight="semibold"
        color="black"
        dataTestid="empty-session-list"
      >
        No resources yet
      </Typography>
      <Show when={isDescriptionVisible}>
        <Typography type="meta" fontWeight="regular" color="gray">
          Start by sharing some resource with the participant.
        </Typography>
      </Show>
    </Flex>
  );
};
